import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfec5be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "header-close" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "content-description" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-body--policy-link" }, "キャンセルポリシー", -1))
const _hoisted_6 = {
  key: 0,
  class: "content-body-container"
}
const _hoisted_7 = { class: "content-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content-body--changed-label" }, "信用スコア", -1))
const _hoisted_9 = { class: "content-body--changed-body" }
const _hoisted_10 = { class: "before" }
const _hoisted_11 = { class: "after" }
const _hoisted_12 = { class: "content-body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content-body--changed-label" }, "最大応募可能件数", -1))
const _hoisted_14 = { class: "content-body--changed-body" }
const _hoisted_15 = { class: "before" }
const _hoisted_16 = { class: "after" }
const _hoisted_17 = { class: "content-caution" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "0pt", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "応募済みのお仕事は全て自動でキャンセル", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "一時的にお仕事へ応募不可", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "footer-actions" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-actions divider" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "text-white footer-actions button--annotation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    id: "confirm-cancel",
    centered: "",
    "dialog-class": "confirm-cancel-modal dialog",
    "content-class": "confirm-cancel-modal content try-cancel-modal",
    "body-class": "confirm-cancel-modal body",
    "header-class": 
      _ctx.willBan
        ? 'confirm-cancel-modal header suspend-alert'
        : 'confirm-cancel-modal header suspend-warning'
    ,
    "no-close-on-backdrop": _ctx.noCloseOnBackdrop,
    "no-close-on-esc": _ctx.noCloseOnEsc,
    onOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-confirm'))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-close')))
  }, {
    "modal-header": _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.willBan
            ? "アカウントが一時停止されます"
            : "アカウントの一時停止にご注意ください"), 1),
      _createTextVNode(),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_FeatherIcon, {
          icon: "x-circle",
          size: "24",
          onClick: close
        }, null, 8, ["onClick"])
      ])
    ]),
    "modal-footer": _withCtx(({ close, ok }) => [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_BButton, {
          block: "",
          variant: "outline-gray-04 text-primary-dark",
          onClick: close,
          class: "footer-actions button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ], undefined, true),
          _: 2
        }, 1032, ["onClick"]),
        _createTextVNode(),
        _hoisted_24,
        _createTextVNode(),
        _createVNode(_component_BButton, {
          block: "",
          variant: "red text-white",
          onClick: ok,
          class: _normalizeClass(
            _ctx.willBan
              ? 'footer-actions button button--alert'
              : 'footer-actions button'
          )
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString("了承する\n")),
            (_ctx.willBan)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "アカウントが一時停止されます"))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 2
        }, 1032, ["onClick", "class"])
      ])
    ]),
    default: _withCtx(() => [
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: {
            name: 'ApplicationCancelPolicy',
            params: {
              applicationId: _ctx.applicationId
            }
          },
            replace: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ], undefined, true),
            _: 1
          }, 8, ["to"]),
          _createTextVNode("\n        に基づき、ペナルティが発生します\n      ")
        ]),
        _createTextVNode(),
        (_ctx.beforeWorkerReliability && _ctx.afterWorkerReliability)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.beforeWorkerReliability.creditScore) + " pt", 1),
                  _createTextVNode("\n            →\n            "),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.afterWorkerReliability.creditScore) + " pt", 1)
                ])
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.beforeWorkerReliability.applyLimit) + " 件", 1),
                  _createTextVNode("\n            →\n            "),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.afterWorkerReliability.applyLimit) + " 件", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_17, [
          _createTextVNode("\n        信用スコアが"),
          _hoisted_18,
          _createTextVNode("になった場合、"),
          _hoisted_19,
          _createTextVNode("となり、"),
          _hoisted_20,
          _createTextVNode("となります。"),
          _hoisted_21,
          _createTextVNode("\n        詳細は"),
          _createElementVNode("a", {
            href: _ctx.creditScoreIsZeroFaqUrl,
            target: "_blank",
            class: "text-primary"
          }, "こちら", 8, _hoisted_22),
          _createTextVNode("をご覧ください。\n      ")
        ])
      ]),
      _createTextVNode()
    ], undefined, true),
    _: 1
  }, 8, ["header-class", "no-close-on-backdrop", "no-close-on-esc"]))
}